
export default {
  props: {
    loading: {type: Boolean, default: false},
    selected: {type: Boolean, default: false},
    count: {type: Number, default: 0},
    max: {type: Number, default: 50}
  },
  computed: {
    c_count() {
      return this.count > this.max ? `${this.max}+` : this.count
    }
  }
}
